<ion-item lines="none" mode="ios" class="para-content" *ngIf="description">
    <ion-label class="ion-text-wrap">
        <div class="user-details" *ngIf="employee">
            <ion-grid>
                <ion-row>
                    <img [src]="employee.imageUrl" default="" alt="">
                    {{ employee?.name != null && employee?.name != '' ? employee?.name : employee?.username }}
                </ion-row>
                <ion-row class="small-data">
                    <span *ngIf="employee.username && showName">
                        {{ 'generic.name' | translate }}: <b>{{ employee.username | uppercase }}</b>
                    </span>
                    <span *ngIf="employee.rank && !hideViewThreeSixtyRank;
">
                        {{ 'generic.rank' | translate }}: <b>{{ employee.rank | uppercase }}</b>
                    </span>
                    <span *ngIf="employee.businessGroup">
                        {{ 'filters.BusinessGroup' | translate }}: <b>{{ employee.businessGroup | uppercase }}</b>
                    </span>
                    <span *ngIf="employee.area">
                        {{ 'generic.area' | translate }}: <b>{{ employee.area | uppercase }}</b>
                    </span>
                    <span *ngIf="employee.lineManager">
                        {{ 'generic.lineManager' | translate }}: <b>{{ employee.lineManager | uppercase }}</b>
                    </span>
                </ion-row>
            </ion-grid>
        </div>
        <p class="para" [innerHtml]="parsedDescription(description)"></p>
        <p *ngIf="extraDescription" class="para" [innerHtml]="parsedDescription(extraDescription)"></p>
    </ion-label>
</ion-item>